import type { CameraCaptureViewport } from "./cameraCaptureLayout";
import {
  readCameraCaptureViewportForModal,
  readHubMainContentWidth,
} from "./cameraCaptureLayout";

/** Live layout inputs for the open camera modal (main column + inner window size). */
export function readCameraCaptureModalLayoutFromWindow(
  windowLike?: Window,
): { viewport: CameraCaptureViewport; pageContentWidth: number } {
  const win =
    windowLike ?? (typeof globalThis !== "undefined" ? globalThis.window : undefined);
  const viewport = readCameraCaptureViewportForModal(win);

  let pageContentWidth = 0;
  if (typeof document !== "undefined") {
    const main = document.querySelector("main");
    if (main instanceof HTMLElement) {
      const rect = main.getBoundingClientRect();
      pageContentWidth = Math.max(main.clientWidth, Math.round(rect.width));
    }
  }
  if (pageContentWidth <= 0) {
    pageContentWidth = readHubMainContentWidth(win);
  }
  if (pageContentWidth <= 0 && win != null && win.innerWidth > 0) {
    pageContentWidth = Math.round(win.innerWidth);
  }

  return { viewport, pageContentWidth };
}
